<template>
  <div
    class="loginPage"
    v-if="
      isLogin ||
      isForgotPassword ||
      isChangePharmacy ||
      isSignicatVerify ||
      isVerifiedUser ||
      isLocationNotAllowed
    "
  >
    <router-view />
  </div>
  <div
    class="main"
    v-if="
      !isLogin &&
      !isForgotPassword &&
      !isChangePharmacy &&
      !isSignicatVerify &&
      !isVerifiedUser &&
      !isLocationNotAllowed
    "
  >
    <Sidebar v-if="!navigation" />
    <div class="page">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';
import { firebaseApp } from './firebase/firebaseInit';

import Sidebar from './views/partial/Sidebar.vue';

import '@/reset.scss';
import { isCypressEnv } from './router';

@Options({
  name: 'Home',
  components: {
    Sidebar
  },
  data: () => {
    return {
      navigation: null
    };
  },
  created() {
    this.checkRoute(this.$route.name);
    if (
      (firebaseApp.auth().currentUser || isCypressEnv()) &&
      this.isNotSignicatVerify
    ) {
      this.getUserProfile();
    }
  },
  computed: {
    isNotSignicatVerify() {
      return !window.location.pathname.includes('verif');
    },
    isLogin() {
      return this.$route.name === 'Login';
    },
    isForgotPassword() {
      return this.$route.name === 'ForgotPassword';
    },
    isChangePharmacy() {
      return this.$route.name === 'ChangePharmacy';
    },
    isSignicatVerify() {
      return this.$route.name === 'SignicatVerify';
    },
    isVerifiedUser() {
      return this.$route.name === 'VerifiedUser';
    },
    isLocationNotAllowed() {
      return this.$route.name === 'LocationNotAllowed';
    }
  },
  methods: {
    ...mapActions('account', ['getUserProfile']),
    checkRoute(): boolean {
      return (
        this.$route.name === 'Login' ||
        this.$route.name === 'ForgotPassword' ||
        this.$route.name === 'ChangePharmacy' ||
        this.$route.name === 'NotFound' ||
        this.$route.name === 'LocationNotAllowed'
      );
    }
  },
  watch: {
    $route(): void {
      this.navigation = this.checkRoute();
    }
  }
})
export default class App extends Vue {}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark-blue;
  margin: 0 auto;
  height: 100%;
  min-height: 100%;
}

* {
  font-family: 'Ubuntu-Regular';
  background-color: $white;
  color: $main-text;
  margin: 0;
}

.error {
  text-align: center;
  font-size: $twelveSize;
  color: $dark-grey;
}

.main {
  display: flex;
}

.page {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
